// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Transactions_tableContainer__6w6fR","table":"Transactions_table__2k3Eg"};